import { QueryConsolePanel } from '@/components/admin/QueryConsolePanel';

export default function QueryConsolePage() {
  return (
    <section className="flex flex-col gap-4">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">Query Console</h2>
        <p className="text-sm text-muted-foreground">
          V8 컬렉션 직접 조회 — count / get + 커서 페이지네이션. 운영자용 raw 쿼리 도구.
        </p>
      </header>
      <QueryConsolePanel />
    </section>
  );
}
